import BaseAdapter from './base';
import Upload from '@/models/Upload';
import { AxiosResponse, AxiosRequestConfig, AxiosError } from 'axios';
import store from "@/store";

export default class UploadAdapter extends BaseAdapter {

    request(options: AxiosRequestConfig): any {
        //Overwrite auth if logged in
        if (store.getters.isLoggedIn) {
            options.auth = {
                username: store.state.account.username,
                password: store.state.account.masterHash,
            };
        }
        return super.request(options);
    }

  public async startUpload(payload: Upload, letterboxAddress: string | null): Promise<Upload> {
      let path: string;
      if (letterboxAddress) {
          path = 'letterboxes/' + letterboxAddress + '/uploads';
      } else {
          path = 'uploads';
      }

      const returned: AxiosResponse = await this.request({
          method: 'post',
          url: path,
          data: payload,
      }) as any;
      return Promise.resolve(returned.data);
  }

  public async uploadChunk(id: string, chunkNumber: string, data: ArrayBuffer,
                           onUploadProgress: (progressEvent: any) => void ) {
    const url = `/uploads/${id}/chunks/${chunkNumber}`;
    const returned: AxiosResponse = await this.request({
        method: 'put',
        url,
        data,
        headers: {
            'Content-Type': 'application/octet-stream',
        },
        onUploadProgress,
    });
    return returned.data;
  }

  public async commitUpload(id: string): Promise<boolean> {
    const url = `/uploads/${id}`;
    const result: AxiosResponse = await this.request({
      method: 'post',
      url,
    });
    return result.data;
  }

}
